@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded) {
    <div class="configuration">
      <app-clm-product-line-header [isOem]="isOem()" [line]="entityLine()" (quantityChanged)="quantityChanged()"
        (tagInformationUpdated)="updateTaggingDetails($event)" [tags]="taggingDetails()">
      </app-clm-product-line-header>
      <app-clm-res-unit-information (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-clm-res-unit-information>
      <app-sp-res-options [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-sp-res-options>
      <app-sp-res-accessories [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-sp-res-accessories>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>
